// Who holds coverage claims (journey-coverage.ts). Dependency-free: the exploration page renders it too.

/** A journey committed before this run or during it, or an in-flight plan's latest draft (`seq`: its decision). */
export type CoverageSource =
  | { kind: 'prior'; journeyId: string }
  | { kind: 'committed'; journeyId: string }
  | { kind: 'reserved'; seq: number | null }

export const SOURCE_TEXT: Record<CoverageSource['kind'], string> = { prior: 'earlier run', committed: 'this run', reserved: 'in flight' }
